import { FhsAPI } from "../../../services/axios";
export const _auth = {
  actions: auth_actions
};

var auth_actions = {
  login({ dispatch }, payload) {
    if (payload.byEds) {
      dispatch("loginByUsername", payload);
    } else {
      dispatch("loginByEds", payload);
    }
  },
  loginByUsername(_, { username, password }) {
    FhsAPI.auth
      .login(username, password)
      .then(res => {
        // console.log(res);
      })
      .catch(err => {
        // console.log(err);
      });
  },
  loginByEds() {}
};
